import { localApi } from './local-api'

const TOKEN_KEY = 'fatigue_bid_token'
const USER_KEY = 'fatigue_bid_user'

function shouldFallback(err, res) {
  if (!res) return true
  // allworld returns HTML placeholder / 404 JSON for unknown APIs
  if (res.status === 404 || res.status === 405 || res.status >= 500) return true
  const ct = res.headers.get('content-type') || ''
  if (!ct.includes('application/json')) return true
  return false
}

export async function api(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' }
  const auth = token ?? localStorage.getItem(TOKEN_KEY)
  if (auth) headers.Authorization = `Bearer ${auth}`

  try {
    const res = await fetch(path, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    })

    const ct = res.headers.get('content-type') || ''
    if (shouldFallback(null, res) || !ct.includes('application/json')) {
      const local = await localApi(path, { method, body, headers })
      if (local) return local
    }

    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      // Prefer local demo runtime on allworld host when Worker API missing
      const local = await localApi(path, { method, body, headers })
      if (local) return local
      const err = new Error(data.error || `HTTP ${res.status}`)
      err.status = res.status
      err.data = data
      throw err
    }
    return data
  } catch (e) {
    if (e.status && e.status < 500 && e.message && !String(e.message).includes('Failed to fetch')) {
      // business errors from localApi
      if (e.status === 401 || e.status === 403 || e.status === 400) throw e
    }
    const local = await localApi(path, { method, body, headers })
    if (local) return local
    throw e
  }
}

export function persistSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function loadSession() {
  const token = localStorage.getItem(TOKEN_KEY)
  const raw = localStorage.getItem(USER_KEY)
  let user = null
  try {
    user = raw ? JSON.parse(raw) : null
  } catch {
    user = null
  }
  return { token, user }
}
